import axios from 'axios'
import config from '../config'

export default {
    getEmailLists(currentPage, perPage, name, category) {
        return axios.get(config.publicPath + 'email_lists', {
            params: {_page: currentPage, itemsPerPage: perPage, name: name, category: category},
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
    getSmartEmailLists() {
        return axios.get(config.publicPath + 'smart_email_lists', {
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
    getEmailListById(emailListId) {
        return axios.get(config.publicPath + 'email_lists/' + emailListId);
    },
    createEmailList(formData) {
        return axios.post(config.publicPath + 'email_lists', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    cloneEmailList(formData) {
        return axios.post(config.publicPath + 'clone-email-list', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
    updateEmailList(id, formData) {
        return axios.put(config.publicPath + 'email_lists/' + id, formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    deleteEmailList(id) {
        return axios.delete(config.publicPath + 'email_lists/' + id,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                validateStatus: function (status) {
                    return status >= 200 && status <= 500;
                },
            });
    },
    getFailedEmailsList(id) {
        return axios({
            'url': config.publicPath + 'email_lists/failed/' + id,
            'method': 'GET',
            responseType: 'blob',
        });
    }
}
